import { t } from '@/utils/lang';

export enum CompletionStatusEnum {
    CompletedAsRequired = 'CompletedAsRequired',
    CompletedWithMonitoring = 'CompletedWithMonitoring',
    NotCompleted = 'NotCompleted',
    Default = 'Default',
}

export const CompletionStatusOptions: {
    label: string;
    value: CompletionStatusEnum;
}[] = [
    {
        label: t('Hoàn tất đúng yêu cầu'),
        value: CompletionStatusEnum.CompletedAsRequired,
    },
    {
        label: t('Hoàn tất nhưng cần theo dõi thêm'),
        value: CompletionStatusEnum.CompletedWithMonitoring,
    },
    { label: t('Chưa hoàn tất'), value: CompletionStatusEnum.NotCompleted },
];
